import React, { useEffect, useMemo, useRef, useState } from "react";
import { Badge } from "reactstrap";

import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import usePersistStoreData from "../../../Components/Hooks/usePersistStoreData";

import { showToast } from "../../../Components/ToastNotification";

const ReKycStepForm = ({ steps }) => {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const { userData } = usePersistStoreData();
  const token = userData?.token;

  const maxProgressRef = useRef(steps);
  if (steps > maxProgressRef.current) {
    maxProgressRef.current = steps;
  }

  const reKycHeadings = [
    { step: 1, label: "Personal & Address Details" },
    { step: 2, label: "Other Information" },
    { step: 3, label: "Bank Details" },
    { step: 4, label: "IPV Details" },
    { step: 5, label: "Documents Upload" },
    { step: 6, label: "e-signature" },
  ];

  const activeStyle = {
    backgroundColor: "#0FA67B",
    color: "white !important",
    padding: "0.7rem",
    borderRadius: "5px",
  };

  const completedStyle = {
    backgroundColor: "#01256D",
    color: "white !important",
    padding: "0.7rem",
    borderRadius: "5px",
  };

  const pendingStyle = {
    backgroundColor: "#f8f9fa",
    color: "#6c757d",
    padding: "0.7rem",
    borderRadius: "5px",
    border: "1px dashed #dee2e6",
  };

  const getStepStyle = (stepNumber) => {
    const progress = maxProgressRef.current || 0; // updated

    if (stepNumber === steps) {
      return activeStyle;
    } else if (stepNumber <= progress) {
      return completedStyle;
    } else {
      return pendingStyle;
    }
  };

  const getStepIcon = (stepNumber) => {
    const progress = maxProgressRef.current || 0; // updated

    if (stepNumber < progress) {
      return <i className="ri-checkbox-circle-fill text-white me-2 fs-16" />;
    } else if (stepNumber === steps) {
      return <i className="ri-play-circle-fill text-white me-2 fs-16" />;
    } else {
      return <i className="ri-radio-button-line text-muted me-2 fs-16" />;
    }
  };

  const getTextClass = (stepNumber) => {
    const progress = maxProgressRef.current || 0; // updated

    if (stepNumber === steps) {
      return "text-white fw-bold";
    } else if (stepNumber <= progress) {
      return "text-white fw-semibold";
    } else {
      return "text-muted";
    }
  };

  return (
    <React.Fragment>
      <div className="re-kyc-steps">
        <div className="d-flex align-items-center justify-content-between mb-4">
          <h5 className="mb-0 text-dark fw-bold">Re-KYC Progress</h5>
          {/* <Badge color="info" pill className="px-3 py-2">
            {steps || 0} of {reKycHeadings?.length} Completed
          </Badge> */}
        </div>

        <div className="text-start mb-1">
          {reKycHeadings.map((item, index) => (
            <div key={index} className="position-relative mb-3">
              <div
                className={`d-flex align-items-center transition-all ${getTextClass(
                  item.step
                )}`}
                style={{
                  ...getStepStyle(item.step),

                  transition: "all 0.3s ease",
                  position: "relative",
                }}
              >
                {/* Step Icon */}
                {getStepIcon(item.step)}

                {/* Step Content */}
                <div className="flex-grow-1">
                  <div className="d-flex align-items-center justify-content-between">
                    <span className="fs-14 mb-0">{item.label}</span>

                    {/* Step Number Badge */}
                    {/* <span
                      className={`ms-2 fs-12 fw-semibold rounded-circle d-flex align-items-center justify-content-center ${
                        item.step <= (steps || 0)
                          ? "bg-success text-white"
                          : item.step === steps
                          ? "bg-primary text-white"
                          : "bg-secondary text-white"
                      }`}
                      style={{
                        width: "1.2rem",
                        height: "1.2rem",
                      }}
                    >
                      {item.step}
                    </span> */}
                  </div>

                  {/* Step Status Text */}
                  <small
                    className={`d-block mt-1 ${
                      item.step <= (steps || 0)
                        ? "text-white-50"
                        : item.step === steps
                        ? "text-white-50"
                        : "text-muted"
                    }`}
                  >
                    {item.step < (maxProgressRef.current || 0)
                      ? "Completed"
                      : item.step === steps
                      ? "In Progress"
                      : "Pending"}
                  </small>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </React.Fragment>
  );
};

export default ReKycStepForm;
